import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseActionMenu from '@/components/base/menus/BaseActionMenu.vue'
import { useActions } from '@/core/composables/useActions'
import { toRef } from 'vue'

interface Props {
  /** The actionable object with actions */
  actionable: HasActionsInterface
  /** Options for action configuration */
  options?: ActionOptions
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ActionMenu'
},
  __name: 'ActionMenu',
  props: {
    actionable: {},
    options: { default: () => ({ labelPath: 'general' }) }
  },
  setup(__props: any) {





const { mappedActions: actions } = useActions(
  toRef(() => __props.actionable),
  toRef(() => __props.options)
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseActionMenu, { actions: _unref(actions) }, null, 8, ["actions"]))
}
}

})